import {
  MODELS_HELPER_TEXT,
  MODELS_PREFIX,
  openAiModelsFetch,
  withAllowedModelsHint,
} from "../models";
import { openaiUsage } from "../openai/usage";
import { OPENAI_COMPATIBLE_USAGE_HINT } from "../openai/usageHint";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const DEFAULT_GROK_BASE_URL = "https://api.x.ai/v1";

const MODELS_ENDPOINT = `${DEFAULT_GROK_BASE_URL}/models`;

const grokModelsFetch = openAiModelsFetch(
  "Fetch models from xAI",
  () => MODELS_ENDPOINT
);

export const grok = defineConnector({
  identifier: "grok",
  name: "Grok",
  tagLine: "xAI large language model API",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.x\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your xAI API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [xAI console](https://console.x.ai/) and generate an API key. See the [API docs](https://docs.x.ai/api) for details.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          placeholder: "xai-...",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Choose available models (optional)",
      items: [
        {
          kind: "list",
          label: "Available models",
          prefix: MODELS_PREFIX,
          columns: [{ field: "name", placeholder: "grok-4" }],
          addLabel: "Add model",
          fetch: grokModelsFetch,
          helperText: MODELS_HELPER_TEXT,
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => MODELS_ENDPOINT,
  },
  usageHint: (configuration) =>
    withAllowedModelsHint(OPENAI_COMPATIBLE_USAGE_HINT, configuration),
  usage: openaiUsage(),
});
